import React, { useContext } from 'react'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { GlobalContext } from '../../App'
import { ApplicationContext } from './MyApplication'
import moduleList from './moduleList'

// Sticky footer for the applicant wizard: back a step, or save and move on.
// Review & submit has its own submit button, so only Back shows there.
const ActionButtons = () => {
  const { selectedModule, goToStep, saveProgress, saving } =
    useContext(ApplicationContext)
  const { setToast } = useContext(GlobalContext)

  const index = moduleList.findIndex((step) => step.key === selectedModule)
  const previous = moduleList[index - 1]
  const next = moduleList[index + 1]

  const handleSaveAndContinue = async () => {
    if (await saveProgress()) {
      goToStep(next.key, { save: false })
      setToast({ message: 'Progress saved' })
    }
  }

  return (
    <Paper
      sx={{
        position: 'sticky',
        bottom: { xs: 8, md: 16 },
        mt: 2,
        px: 2,
        py: 1.5,
        zIndex: 2,
        boxShadow: '0 -2px 12px rgba(15, 23, 42, 0.08)',
      }}
    >
      <Stack direction="row" gap={1} justifyContent="space-between">
        <Button
          color="inherit"
          startIcon={<ArrowBackIcon />}
          disabled={!previous}
          onClick={() => previous && goToStep(previous.key)}
        >
          Back
        </Button>
        {next && (
          <Button
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            onClick={handleSaveAndContinue}
            disabled={saving}
          >
            Save & continue
          </Button>
        )}
      </Stack>
    </Paper>
  )
}

export default ActionButtons
